export const REQUIRED_TYPE_ERROR = 'Select the type of the document';
